/* URBAN VINYLS — Paginación de colecciones.
   Dos modos:
   1) Normal (otro orden o filtros): Shopify pagina; en móvil el botón "Cargar más" trae la siguiente página por fetch.
   2) Orden por artista (por defecto): los productos llegan ordenados (si hay más de 250, se traen
      los bloques restantes y se reordenan aquí por su clave data-uv-key) y se paginan aquí:
      - Ordenador: páginas numeradas (?pagina=N).
      - Móvil: "Cargar más" va mostrando los siguientes.
   En móvil, al volver atrás desde un producto, se recupera lo cargado y se vuelve a la tarjeta de ese producto. */
(function () {
  var KEY = 'uv-loadmore:' + location.pathname;
  var MAX_AGE = 30 * 60 * 1000; // 30 min
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function save(data) { try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function state() { return load() || { pages: 0, scroll: 0, product: null, at: 0 }; }
  function grid() { return document.getElementById('product-grid'); }

  function sectionUrl(url, sectionId) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
  }

  /* ---------- Modo orden por artista: mostrar un rango de productos ---------- */
  function showRange(from, to) {
    var g = grid(); if (!g) return;
    var items = g.children;
    for (var i = 0; i < items.length; i++) items[i].classList.toggle('uv-show', i >= from && i < to);
    g.classList.add('uv-ready');
  }

  function updateCount(block, shown) {
    var total = parseInt(block.getAttribute('data-total'), 10) || 0;
    shown = Math.min(shown, total);
    var shownEl = block.querySelector('[data-uv-shown]');
    if (shownEl) shownEl.textContent = shown;
    var bar = block.querySelector('[data-uv-bar]');
    if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
    var btn = block.querySelector('[data-uv-loadmore-btn]');
    if (btn) btn.hidden = shown >= total;
  }

  function hasMore(block) {
    if (block.getAttribute('data-client') === '1') {
      var total = parseInt(block.getAttribute('data-total'), 10) || 0;
      var per = parseInt(block.getAttribute('data-per'), 10) || 24;
      return (parseInt(block.dataset.revealed || '1', 10) * per) < total;
    }
    return !!block.getAttribute('data-next');
  }

  function revealNext(block, opts) {
    var per = parseInt(block.getAttribute('data-per'), 10) || 24;
    var k = parseInt(block.dataset.revealed || '1', 10) + 1;
    block.dataset.revealed = k;
    showRange(0, per * k);
    updateCount(block, per * k);
    if (!(opts && opts.restoring)) { var s = state(); s.pages += 1; s.at = Date.now(); save(s); }
    return Promise.resolve(true);
  }

  /* ---------- Modo normal: traer la siguiente página de Shopify ---------- */
  function loadNext(block, opts) {
    if (block.getAttribute('data-client') === '1') return revealNext(block, opts);
    var g = grid();
    var btn = block.querySelector('[data-uv-loadmore-btn]');
    var label = block.querySelector('[data-uv-label]');
    var next = block.getAttribute('data-next');
    if (!g || !next || block.dataset.loading === '1') return Promise.resolve(false);

    block.dataset.loading = '1';
    var oldText = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = 'Cargando…';

    return fetch(sectionUrl(next, block.getAttribute('data-section')))
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (li) {
          li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          g.appendChild(document.importNode(li, true));
        });
        var shownEl = block.querySelector('[data-uv-shown]');
        var shown = (parseInt(shownEl && shownEl.textContent, 10) || 0) + items.length;
        updateCount(block, shown);
        if (!(opts && opts.restoring)) { var s = state(); s.pages += 1; s.at = Date.now(); save(s); }

        var nextBlock = doc.querySelector('[data-uv-loadmore]');
        if (nextBlock && nextBlock.getAttribute('data-next')) {
          block.setAttribute('data-next', nextBlock.getAttribute('data-next'));
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (label) label.textContent = oldText;
        } else {
          block.removeAttribute('data-next');
          if (btn) btn.remove();
        }
        block.dataset.loading = '';
        return true;
      })
      .catch(function (e) {
        console.warn('[UV] No se pudieron cargar más productos:', e);
        block.dataset.loading = '';
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (label) label.textContent = oldText;
        if (next && !(opts && opts.restoring)) location.href = next;
        return false;
      });
  }

  /* ---------- Ordenador: páginas numeradas en el modo orden por artista ---------- */
  if (!customElements.get('uv-cpager')) {
    customElements.define('uv-cpager', class extends HTMLElement {
      connectedCallback() {
        this.per = parseInt(this.dataset.per, 10) || 24;
        this.total = parseInt(this.dataset.total, 10) || 0;
        this.pages = Math.max(1, Math.ceil(this.total / this.per));
        this.nav = this.querySelector('[data-uv-cpager-nav]');
        this.block = this.querySelector('[data-uv-loadmore]');
        this.onPop = this.render.bind(this);
        this.onMode = this.render.bind(this);
        window.addEventListener('popstate', this.onPop);
        if (MOBILE.addEventListener) MOBILE.addEventListener('change', this.onMode);
        this.render();
        this.loadRest();
      }
      // Más de 250 productos: Shopify los da en bloques de 250. Traemos el resto, juntamos y reordenamos A-Z.
      loadRest() {
        var self = this, n = parseInt(this.dataset.pages, 10) || 1, sec = this.dataset.section;
        if (n < 2 || !sec || this.dataset.merged) return;
        this.dataset.merged = '1';
        var reqs = [];
        for (var p = 2; p <= n; p++) {
          var params = new URLSearchParams(location.search);
          params.delete('pagina'); params.set('page', p); params.set('section_id', sec);
          reqs.push(fetch(location.pathname + '?' + params.toString()).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status); return r.text();
          }));
        }
        Promise.all(reqs).then(function (pages) {
          var g = grid(); if (!g) return;
          var seen = {};
          Array.prototype.forEach.call(g.children, function (li) { var a = li.querySelector('a[href*="/products/"]'); if (a) seen[a.getAttribute('href').split('?')[0]] = 1; });
          pages.forEach(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('#product-grid > li').forEach(function (li) {
              var a = li.querySelector('a[href*="/products/"]');
              var h = a ? a.getAttribute('href').split('?')[0] : null;
              if (h && seen[h]) return;
              if (h) seen[h] = 1;
              li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
              g.appendChild(document.importNode(li, true));
            });
          });
          var items = Array.prototype.slice.call(g.children);
          items.sort(function (a, b) {
            var x = a.getAttribute('data-uv-key') || '', y = b.getAttribute('data-uv-key') || '';
            return x < y ? -1 : x > y ? 1 : 0;
          });
          items.forEach(function (li) { g.appendChild(li); });
          self.render();
        }).catch(function (e) { console.warn('[UV] No se pudo completar el orden A-Z:', e); });
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPop);
        if (MOBILE.removeEventListener) MOBILE.removeEventListener('change', this.onMode);
      }
      page() {
        var p = parseInt(new URLSearchParams(location.search).get('pagina'), 10) || 1;
        return Math.min(Math.max(1, p), this.pages);
      }
      url(p) {
        var params = new URLSearchParams(location.search);
        if (p > 1) params.set('pagina', p); else params.delete('pagina');
        var q = params.toString();
        return location.pathname + (q ? '?' + q : '');
      }
      render() {
        if (MOBILE.matches) {
          var k = parseInt(this.block.dataset.revealed || '1', 10);
          showRange(0, this.per * k);
          updateCount(this.block, this.per * k);
          return;
        }
        var p = this.page();
        showRange((p - 1) * this.per, p * this.per);
        this.renderNav(p);
      }
      renderNav(p) {
        var self = this, n = this.pages, html = '';
        function item(i, label, cls, aria) {
          if (i === p && !cls) {
            return '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Página ' + i + '">' + i + '</a></li>';
          }
          return '<li><a href="' + self.url(i) + '" data-page="' + i + '" class="pagination__item link ' + (cls || '') + '"' + (aria ? ' aria-label="' + aria + '"' : ' aria-label="Página ' + i + '"') + '>' + label + '</a></li>';
        }
        if (p > 1) html += item(p - 1, '‹', 'pagination__item--prev pagination__item-arrow', 'Página anterior');
        var pages = [];
        for (var i = 1; i <= n; i++) {
          if (i === 1 || i === n || Math.abs(i - p) <= 1 || n <= 7) pages.push(i);
          else if (pages[pages.length - 1] !== '…') pages.push('…');
        }
        pages.forEach(function (i) { html += i === '…' ? '<li><span class="pagination__item">…</span></li>' : item(i, i); });
        if (p < n) html += item(p + 1, '›', 'pagination__item--next pagination__item-arrow', 'Página siguiente');
        this.nav.innerHTML = '<nav class="pagination" role="navigation" aria-label="Paginación"><ul class="pagination__list list-unstyled" role="list">' + html + '</ul></nav>';
        this.nav.querySelectorAll('a[data-page]').forEach(function (a) {
          a.addEventListener('click', function (e) {
            e.preventDefault();
            history.pushState({}, '', self.url(parseInt(a.dataset.page, 10)));
            self.render();
            var g = grid();
            if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
          });
        });
      }
    });
  }

  /* ---------- Clicks: "Cargar más" y guardar a qué producto vamos ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-uv-loadmore-btn]');
    if (btn) {
      e.preventDefault();
      loadNext(btn.closest('[data-uv-loadmore]'));
      return;
    }
    var link = e.target.closest && e.target.closest('#product-grid a[href*="/products/"]');
    if (link) {
      var s = state();
      s.product = link.getAttribute('href').split('?')[0];
      s.scroll = window.scrollY;
      s.at = Date.now();
      save(s);
    }
  }, true);

  function remember() {
    var s = load();
    if (s && s.pages > 0) { s.scroll = window.scrollY; s.at = Date.now(); save(s); }
  }
  window.addEventListener('pagehide', remember);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') remember(); });

  function goToSaved(s) {
    var card = null;
    if (s.product) {
      var a = document.querySelector('#product-grid a[href^="' + s.product + '"]');
      card = a && a.closest('li');
    }
    if (card && card.offsetParent !== null) card.scrollIntoView({ block: 'center' });
    else window.scrollTo(0, s.scroll || 0);
  }

  function isReturning(s) {
    if (!s || !s.pages) return false;
    if (Date.now() - (s.at || 0) > MAX_AGE) return false;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') return true;
    return !!(s.product && document.referrer && document.referrer.indexOf(s.product) > -1);
  }

  // Móvil: al volver atrás, recuperar lo cargado y la posición
  function restore() {
    var s = load();
    if (!isReturning(s)) { clear(); return; }
    var block = document.querySelector('[data-uv-loadmore]');
    if (!block || getComputedStyle(block).display === 'none') return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var target = s.pages, i = 0;
    (function step() {
      if (i >= target || !hasMore(block)) {
        goToSaved(s);
        setTimeout(function () { goToSaved(s); }, 350);
        window.addEventListener('load', function () { goToSaved(s); }, { once: true });
        return;
      }
      i += 1;
      loadNext(block, { restoring: true }).then(function (ok) { if (ok) step(); else goToSaved(s); });
    })();
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var s = load();
    if (s && s.pages > 0 && window.scrollY < 50 && Date.now() - (s.at || 0) < MAX_AGE) goToSaved(s);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
  else restore();
})();
